import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../../provider/CommonContext";
import { Col, Container, Row } from 'react-bootstrap';
import './RollOver.css';
import Pagination from '../../../CommonUI/Pagination/Pagination';
import { format, parseISO } from 'date-fns';
import MarketFandO from "../../MarketFandO";
import { Vortex } from 'react-loader-spinner'


function RollOver() {
    const [data, setData] = useState([]);

    const [dataGroup, setDataGroup] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [loadingshow, setloadingshow] = useState(false);
    const { BaseURL } = useContext(URLstateContext);
    let getData, getDataGroup, eleBtn, eleBtnLoose, eleLi;
    let PageSize = 8;


    useEffect(() => {
        setloadingshow(true);
        const getUrl = BaseURL + "RollOver";


        fetch(`${getUrl}`)
            .then((response) => response.json())
            .then((data) => {
                getData = data.data;
                setData(getData);
                setloadingshow(false);
                // console.log(getData, "getData")
            })
            .catch((error) => {
            });


    }, []);



    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);


    return (
        <>
            <div class="col-12 p-0 breadcrumMF ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/futures-and-options">F & O</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>Roll Over</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='Roll-loser-sc'>
                            <div className='Roll-header'>
                                <h2><span>Roll Over</span></h2>
                            </div>
                            <MarketFandO optionValue="Roll Over" optionDrop="Derivative" />
                            {/* <hr className="Mosthr"></hr> */}
                            <div className='Roll-table table-responsive'>
                                <table className='table'>
                                    <thead>
                                        <tr>

                                            <th className="bdrright text-left" >Symbol</th>
                                            <th className="bdrright text-center bdrbottom" colspan="2">Current Month</th>
                                            <th className="bdrright text-center bdrbottom" colspan="2">Next Month</th>
                                            <th className="text-center bdrbottom" colspan="4" >Roll Over</th>

                                        </tr>
                                        <tr>
                                            <th className="bdrright"> </th>

                                            <th className="bdrright text-right">Open Interest</th>
                                            <th className="bdrright text-right">Change OI</th>
                                            <th className="bdrright text-right">Open Interest</th>
                                            <th className="bdrright text-right">Change OI</th>
                                            <th className="bdrright text-right">Today</th>
                                            <th className="bdrright text-right">Previous</th>
                                            <th className="bdrright text-right">Total</th>
                                            <th class='text-right'>(%)</th>
                                        </tr>

                                    </thead>
                                    <tbody>
                                        {currentTableData && currentTableData.map(

                                            ({ Symbol, CurrentOI, CurrentChgOI, NextOI, NextOIChg, TodayRollOver, LastRollOver, TotalRollOver, RollOver }) => (
                                                <tr>

                                                    <td className="text-left"> {Symbol}</td>

                                                    <td className="text-right"> {CurrentOI}</td>
                                                    <td className="text-right"> {CurrentChgOI}</td>
                                                    <td className="text-right"> {NextOI}</td>
                                                    <td className="text-right"> {NextOIChg}</td>
                                                    <td className="text-right"> {(TodayRollOver != null) ? TodayRollOver.toFixed(2) : 0}</td>
                                                    <td className="text-right"> {(LastRollOver != null) ? LastRollOver.toFixed(2) : 0}</td>
                                                    <td className="text-right"> {(TotalRollOver != null) ? TotalRollOver.toFixed(2) : 0}</td>
                                                    <td className="text-right"> {(RollOver != null) ? RollOver.toFixed(2) : 0}</td>

                                                </tr>
                                            ))}
                                    </tbody>
                                </table>
                                {loadingshow ? <div className="textcentervertex">
                                                        <Vortex
                                                            visible={true}
                                                            height="80"
                                                            width="80"
                                                            ariaLabel="vortex-loading"
                                                            wrapperStyle={{}}
                                                            wrapperClass="vortex-wrapper"
                                                            colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                                        />
                                                        <div className="model_popup">Please Wait...</div>
                                                    </div> : ""
                                                    }
                            </div>
                            {(data != null && data != []) ?
                                <Pagination
                                    className="pagination-bar_peer"
                                    currentPage={currentPage}
                                    totalCount={(data.length != null) ? data.length : 0}
                                    pageSize={PageSize}
                                    onPageChange={page => setCurrentPage(page)}
                                /> : <p className="errorPeer"> No Data Found !!! </p>}

                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default RollOver;